<template>
  <div class="ls-switch" :class="themedClass">
    <label class="ls-switch--switch">
      <input v-model="localValue" type="checkbox" :disabled="disabled" test-id="ls-switch" />
      <span
        :class="[
          'ls-switch--slider',
          { elastic: isElastic && !disabled, 'ls-switch--disabled': disabled },
        ]"
        @mousedown="isElastic = true"
        @mouseup="isElastic = false"
      />
    </label>
    <span
      class="ls-switch--inner-labels left"
      :class="{ 'ls-switch--hidden': !localValue, 'ls-switch--disabled': disabled }"
      >No</span
    >
    <span
      class="ls-switch--inner-labels"
      :class="{ 'ls-switch--hidden': localValue, 'ls-switch--disabled': disabled }"
      >Yes</span
    >
  </div>
</template>

<script>
import { lsPropTypeHelpers, lsTrackingService } from 'ls-vue-common';
import VueTypes from 'vue-types';
import { themedComponentMixin } from '@/mixins';

export default {
  name: 'LsSwitch',
  mixins: [themedComponentMixin],
  props: {
    trackId: VueTypes.custom(lsPropTypeHelpers.trackID).isRequired,
    value: VueTypes.bool.isRequired,
    disabled: VueTypes.bool.def(false),
  },
  data() {
    return {
      isElastic: false,
    };
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(value) {
        lsTrackingService.track({
          event: 'click',
          target: this.trackId,
          data: { value },
        });
        this.$emit('input', value);
      },
    },
  },
};
</script>

<style lang="scss">
.ls-switch {
  position: relative;
  .ls-switch--switch {
    position: relative;
    display: inline-block;
    width: 74px;
    height: 27px;
  }

  .ls-switch--switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .ls-switch--slider {
    position: absolute;
    cursor: pointer;
    &.ls-switch--disabled {
      cursor: not-allowed;
    }
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transition: 0.3s;
    box-shadow: 0px 0px 0px 1px $gray-tertiary;
    border-radius: 34px;
    &.elastic:before {
      width: 44px;
    }
  }

  .ls-switch--slider:before {
    line-height: 2.2rem;
    text-align: center;
    font-weight: 700;
    font-size: $size-6;
    color: $primary;
    position: absolute;
    content: 'No';
    height: 23px;
    width: 40px;
    left: 2px;
    bottom: 2px;
    background-color: $primary-light;
    transition: 0.2s;
    border-radius: 15px;
  }

  input:focus + .ls-switch--slider {
    box-shadow: 0 0 1px 1px $primary;
  }

  input:checked + .ls-switch--slider:before {
    content: 'Yes';
    transform: translateX(30px);
    background-color: $primary;
    color: $primary-light;
  }

  input:checked + .elastic.ls-switch--slider:before {
    transform: translateX(26px);
  }

  .ls-switch--inner-labels {
    cursor: pointer;
    pointer-events: none;
    user-select: none;
    font-size: $size-6;
    font-weight: 700;
    color: $gray-tertiary;
    padding-top: 4px;
    position: absolute;
    left: 45px;
    opacity: 1;
    transition: all 200ms;
  }

  .ls-switch--inner-labels.left {
    left: 9px;
  }

  .ls-switch--hidden {
    visibility: hidden;
    opacity: 0;
  }

  .ls-switch--disabled {
    opacity: 0.5;
  }

  &.themed-component {
    .ls-switch--slider {
      box-shadow: 0px 0px 0px 1px $theme-color-gray-dark;
    }

    .ls-switch--slider:before {
      font-size: var(--theme-txt-body-sm);
      color: $theme-color-primary;
      background-color: $theme-color-primary-light;
    }

    input {
      &:focus {
        & + .ls-switch--slider {
          box-shadow: 0 0 1px 1px $theme-color-primary;
        }
      }
      &:checked {
        & + .ls-switch--slider:before {
          background-color: $theme-color-primary;
          color: $theme-color-primary-light;
        }
      }
    }
    .ls-switch--inner-labels {
      font-size: var(--theme-txt-body-sm);
      color: $theme-color-gray-dark;
    }
  }
}
</style>
